import type { AxiosInstance } from "axios";
import { K8sResourceProxy } from "./cluster-resource-proxy";
import { SecretItemSchema } from "../schema/k8s-resource/secret";
import { axiosInstance } from "@kce2/app/axios";

/**
 * Secret 相关 API。
 *
 * 组合 K8sResourceProxy（不继承共享基类，见 docs/adr/0001），
 * 在其上封装 Secret 列表查询（用于 CA 证书下拉）。
 *
 * apiVersion/resourceType 作为方法参数带默认值，避免将来为不同 K8s 版本资源新建 class。
 */
export class SecretApi {
  private proxy: K8sResourceProxy;

  constructor(axios: AxiosInstance = axiosInstance) {
    this.proxy = new K8sResourceProxy(axios);
  }

  /**
   * 列出指定 namespace 下的 Secret，用于 CA 证书下拉选择。
   *
   * - 响应 item schema 仅含展示字段，不含 `data`（凭据数据不进入前端）。
   * - `type` 映射为 fieldSelector `type==${type}` 传给后端（与 envoy createDrawer 一致）。
   */
  listSecrets(params: {
    region: string;
    clusterId: string;
    namespace: string;
    type?: string;
  }) {
    const { region, clusterId, namespace, type } = params;
    return this.proxy.listResources({
      region,
      clusterId,
      apiVersion: "v1",
      resourceType: "secrets",
      namespace,
      ...(type && { fieldSelector: `type==${type}` }),
      itemSchema: SecretItemSchema,
    });
  }
}

export const secretApi = new SecretApi();
